module.exports = "<div class=\"tab-panel-stage {{themeClass}}\"> <tab theme=secondary :current-index=switchingIndex :items=tabItems></tab> <switching class=panel-wrap :switch-num=tabItems.length :compile-vm=compileVm :current-index=switchingIndex v-ref:switching> </switching> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/common/tab-panel/tab-panel.tpl
// module id = 958
// module chunks = 2